// extracted by mini-css-extract-plugin
module.exports = {"root":"MarketingGifts_root__r0coZ","content":"MarketingGifts_content__3n0me","stateText":"MarketingGifts_stateText__1CpoV","stateHint":"MarketingGifts_stateHint__3lfsr"};